var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    {
      attrs: {
        autocomplete: "off"
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:".concat(_vm.usernameMaxlength),
                    expression: "`required|max:${usernameMaxlength}`"
                  }
                ],
                attrs: {
                  autocomplete: "off",
                  label: "Username",
                  name: "dbUser",
                  prefix: _vm.usernamePrefix,
                  counter: _vm.usernameMaxlength,
                  "error-messages": _vm.errors.collect("dbUser")
                },
                model: {
                  value: _vm.name,
                  callback: function callback($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("compact-password", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  "cpanel-app": "mysql",
                  "show-strength": "",
                  outlined: "",
                  label: "Password",
                  "data-vv-name": "password",
                  "data-vv-as": "Password",
                  "error-messages": _vm.errors.collect("password"),
                  "with-generator": ""
                },
                model: {
                  value: _vm.password,
                  callback: function callback($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.submitButton
        ? _c(
            "gg-btn",
            {
              attrs: {
                loading: _vm.loading
              },
              on: {
                click: _vm.createUser
              }
            },
            [_vm._v(" Create User ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }